<!-- align-items-center leads to messed up content layout -->
<div class="container-fluid vh-100 d-flex justify-content-center">
  <div [ngSwitch]="navigationInfo.section + '-' + navigationInfo.title">
    <!-- Introduction -->
    <app-instruction-container-bg-half
      *ngSwitchCase="'introduction-welcome'"
      [instruction]="'welcome'"
      [label]="studyStartContinueButtonLabel"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-half>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'introduction-consent'"
      [showConsent]="true"
      [label]="continueButtonLabel"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <!-- Persona -->
    <app-instruction-container-bg-mono
      *ngSwitchCase="'persona-intro'"
      [label]="continueButtonLabel"
      [instruction]="'persona-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'persona-baseline-intro'"
      [label]="continueButtonLabel"
      [instruction]="'persona-baseline-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-test-display
      *ngSwitchCase="'persona-baseline-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'persona-how-to'"
      [label]="continueButtonLabel"
      [instruction]="'persona-how-to'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'persona-instruction-speed'"
      [label]="continueButtonLabel"
      [instruction]="'persona-instruction-speed'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'persona-practice-intro'"
      [label]="continueButtonLabel"
      [instruction]="'persona-practice-intro'"
      [section]="navigationInfo.section"
      [showContinue]="false"
      [isPracticeIntro]="true"
    ></app-instruction-container-bg-mono>

    <app-test-display
      *ngSwitchCase="'persona-practice-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-test-display
      *ngSwitchCase="'persona-IAT-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-instruction-container
      *ngSwitchCase="'persona-IAT-question'"
      [instruction]="'persona-IAT-question'"
      [time]="IATQuestionDisplayLength"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'persona-countdown'"
      [showCountdown]="true"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'persona-IAT-finger-placement'"
      [section]="navigationInfo.section"
      [instruction]="'persona-IAT-finger-placement'"
      [time]="fingerPlacementDisplayLength"
    ></app-instruction-container>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'persona-IAT-intro'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'persona-IAT-intro'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'persona-section-end'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'persona-section-end'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <!-- Brand -->
    <app-instruction-container-bg-mono
      *ngSwitchCase="'brand-intro'"
      [label]="continueButtonLabel"
      [instruction]="'brand-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'brand-baseline-intro'"
      [label]="continueButtonLabel"
      [instruction]="'brand-baseline-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-test-display
      *ngSwitchCase="'brand-baseline-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'brand-how-to'"
      [label]="continueButtonLabel"
      [instruction]="'brand-how-to'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'brand-instruction-speed'"
      [label]="continueButtonLabel"
      [instruction]="'brand-instruction-speed'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'brand-practice-intro'"
      [label]="continueButtonLabel"
      [instruction]="'brand-practice-intro'"
      [section]="navigationInfo.section"
      [showContinue]="false"
      [isPracticeIntro]="true"
    ></app-instruction-container-bg-mono>

    <app-image-full
      *ngSwitchCase="'brand-practice-image'"
      [instruction]="'brand-practice-image'"
      [section]="navigationInfo.section"
      [label]="continueButtonLabel"
    ></app-image-full>

    <app-instruction-container
      *ngSwitchCase="'brand-IAT-question'"
      [instruction]="'brand-IAT-question'"
      [time]="IATQuestionDisplayLength"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'brand-countdown'"
      [showCountdown]="true"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'brand-IAT-finger-placement'"
      [section]="navigationInfo.section"
      [instruction]="'brand-IAT-finger-placement'"
      [time]="fingerPlacementDisplayLength"
    ></app-instruction-container>

    <app-test-display
      *ngSwitchCase="'brand-practice-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'brand-IAT-intro'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'brand-IAT-intro'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <app-image-full
      *ngSwitchCase="'brand-IAT-image'"
      [instruction]="'brand-IAT-image'"
      [section]="navigationInfo.section"
      [label]="continueButtonLabel"
      [isPractice]="false"
    ></app-image-full>

    <app-test-display
      *ngSwitchCase="'brand-IAT-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'brand-section-end'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'brand-section-end'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <!-- Modular -->
    <app-instruction-container-bg-mono
      *ngSwitchCase="'modular-intro'"
      [label]="continueButtonLabel"
      [instruction]="'modular-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'modular-baseline-intro'"
      [label]="continueButtonLabel"
      [instruction]="'modular-baseline-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-test-display
      *ngSwitchCase="'modular-baseline-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'modular-how-to'"
      [label]="continueButtonLabel"
      [instruction]="'modular-how-to'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'modular-instruction-speed'"
      [label]="continueButtonLabel"
      [instruction]="'modular-instruction-speed'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'modular-practice-intro'"
      [label]="continueButtonLabel"
      [instruction]="'modular-practice-intro'"
      [section]="navigationInfo.section"
      [showContinue]="false"
      [isPracticeIntro]="true"
    ></app-instruction-container-bg-mono>

    <app-test-display
      *ngSwitchCase="'modular-practice-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-test-display
      *ngSwitchCase="'modular-IAT-test'"
      [intermissionButtonLabel]="intermissionButtonLabel"
    ></app-test-display>

    <app-instruction-container
      *ngSwitchCase="'modular-IAT-question'"
      [instruction]="'modular-IAT-question'"
      [time]="IATQuestionDisplayLength"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'modular-countdown'"
      [showCountdown]="true"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'modular-IAT-finger-placement'"
      [section]="navigationInfo.section"
      [instruction]="'modular-IAT-finger-placement'"
      [time]="fingerPlacementDisplayLength"
    ></app-instruction-container>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'modular-IAT-intro'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'modular-IAT-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'modular-section-end'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'modular-section-end'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <!-- IAT -->
    <app-instruction-container-bg-mono
      *ngSwitchCase="'IAT-intro'"
      [label]="continueButtonLabel"
      [instruction]="'IAT-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'IAT-how-to'"
      [label]="continueButtonLabel"
      [instruction]="'IAT-how-to'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-iat-display *ngSwitchCase="'IAT-IAT-test'"></app-iat-display>

    <app-instruction-container
      *ngSwitchCase="'IAT-IAT-question'"
      [instruction]="'IAT-IAT-question'"
      [time]="IATQuestionDisplayLength"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'IAT-countdown'"
      [showCountdown]="true"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'IAT-IAT-finger-placement'"
      [section]="navigationInfo.section"
      [instruction]="'IAT-IAT-finger-placement'"
      [time]="fingerPlacementDisplayLength"
    ></app-instruction-container>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'IAT-section-end'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'IAT-section-end'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <!-- Conjoint -->

    <app-instruction-container-bg-mono
      *ngSwitchCase="'conjoint-intro'"
      [label]="continueButtonLabel"
      [instruction]="'conjoint-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'conjoint-practice-intro'"
      [label]="continueButtonLabel"
      [instruction]="'conjoint-practice-intro'"
      [section]="navigationInfo.section"
      [showContinue]="true"
      [isPracticeIntro]="true"
    ></app-instruction-container-bg-mono>

    <app-conjoint-display
      *ngSwitchCase="'conjoint-practice-test'"
    ></app-conjoint-display>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'conjoint-IAT-intro'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'conjoint-IAT-intro'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <app-conjoint-display
      *ngSwitchCase="'conjoint-IAT-test'"
    ></app-conjoint-display>

    <app-instruction-container
      *ngSwitchCase="'conjoint-IAT-question'"
      [instruction]="'conjoint-IAT-question'"
      [time]="IATQuestionDisplayLength"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'conjoint-countdown'"
      [showCountdown]="true"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'conjoint-IAT-finger-placement'"
      [section]="navigationInfo.section"
      [instruction]="'conjoint-IAT-finger-placement'"
      [time]="fingerPlacementDisplayLength"
    ></app-instruction-container>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'conjoint-section-end'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'conjoint-section-end'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <!-- priming -->
    <app-instruction-container-bg-mono
      *ngSwitchCase="'priming-intro'"
      [label]="continueButtonLabel"
      [instruction]="'priming-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'priming-how-to'"
      [label]="continueButtonLabel"
      [instruction]="'priming-how-to'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-priming-display
      *ngSwitchCase="'priming-IAT-test'"
    ></app-priming-display>

    <app-instruction-container
      *ngSwitchCase="'priming-IAT-question'"
      [instruction]="'priming-IAT-question'"
      [time]="IATQuestionDisplayLength"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'priming-countdown'"
      [showCountdown]="true"
      [section]="navigationInfo.section"
    ></app-instruction-container>

    <app-instruction-container
      *ngSwitchCase="'priming-IAT-finger-placement'"
      [section]="navigationInfo.section"
      [instruction]="'priming-IAT-finger-placement'"
      [time]="fingerPlacementDisplayLength"
    ></app-instruction-container>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'priming-section-end'"
      [showConsent]="false"
      [label]="continueButtonLabel"
      [instruction]="'priming-section-end'"
      [section]="navigationInfo.section"
      [bgColor]="BgColors.IMG"
    ></app-instruction-container-bg-mono>

    <!-- Questionnaire -->
    <app-instruction-container-bg-mono
      *ngSwitchCase="'questionnaire-intro'"
      [label]="continueButtonLabel"
      [instruction]="'questionnaire-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-questionnaire
      *ngSwitchCase="'questionnaire-questionnaire'"
    ></app-questionnaire>

    <app-instruction-container-bg-mono
      *ngSwitchCase="'questionnaire-section-end'"
      [label]="continueButtonLabel"
      [instruction]="'questionnaire-section-end'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <!-- Media -->
    <app-instruction-container-bg-mono
      *ngSwitchCase="'pdf-intro'"
      [label]="continueButtonLabel"
      [instruction]="'pdf-intro'"
      [section]="navigationInfo.section"
    ></app-instruction-container-bg-mono>

    <app-media-display
      *ngSwitchCase="'pdf-viewer'"
      [label]="mediaContinueButtonLabel"
    >
    </app-media-display>

    <!-- Final -->
    <app-instruction-container-bg-mono
      *ngSwitchCase="'final-final'"
      [label]="continueButtonLabel"
      [showContinue]="false"
      [instruction]="'final-final'"
      [section]="navigationInfo.section"
      [isFinalPage]="true"
    ></app-instruction-container-bg-mono>

    <!-- Overview pages -->
    <app-overview *ngSwitchCase="'introduction-overview'"></app-overview>
    <app-overview *ngSwitchCase="'persona-overview'"></app-overview>
    <app-overview *ngSwitchCase="'brand-overview'"></app-overview>
    <app-overview *ngSwitchCase="'modular-overview'"></app-overview>
    <app-overview *ngSwitchCase="'IAT-overview'"></app-overview>
    <app-overview *ngSwitchCase="'priming-overview'"></app-overview>
    <app-overview *ngSwitchCase="'conjoint-overview'"></app-overview>
    <app-overview *ngSwitchCase="'questionnaire-overview'"></app-overview>
  </div>
</div>
